import { render, staticRenderFns } from "./NoPhoneFreeProduct.vue?vue&type=template&id=36ca74a4"
import script from "./NoPhoneFreeProduct.vue?vue&type=script&lang=js"
export * from "./NoPhoneFreeProduct.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports